<template>

  <vs-row

  vs-type="flex" vs-justify="space-between" vs-w="12">
 
  <vs-col  vs-type="flex" vs-justify="center"  vs-w="8" vs-sm="6" vs-xs="12" >
    <vs-card  style=" border-radius: 20px;">
       <vs-list-header icon="new_releases" title="Notification" style="font-size: 18px;" color="danger"></vs-list-header>
<!--       
       <scrolly class="foo" :style="{ width: '100%', height: '200px' }">
  <scrolly-viewport> -->
    <vs-table  :data="alertlist"  pagination maxItems='4'>
     
      <template slot="thead" >
        <vs-th style="padding: 0px">
         
        </vs-th>
        <vs-th id="noWrap">
          Alert Name
        </vs-th>
        <vs-th id="noWrap">
          Condition
        </vs-th>
        <vs-th id="noWrap">
          Sensor Name
        </vs-th>
        <vs-th id="noWrap">
          Reading Data
        </vs-th>
        <vs-th id="noWrap">
          Timestamp
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td>
           <a href="javascript:void(0)" class="text-danger">
                <vs-icon icon="delete_sweep"></vs-icon>
              </a>
          </vs-td>
          <vs-td>
            <span class="font-weight-normal badge badge-warning badge-pill px-2 py-1"> {{data[indextr].name}}</span>
           
          </vs-td>
          <vs-td>
            {{data[indextr].con}}
          </vs-td>
          <vs-td>
            {{data[indextr].sensname}}
          </vs-td>
          <vs-td>
            {{data[indextr].data}}
          </vs-td>
          <vs-td>
            {{data[indextr].timestamp}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  <!-- </scrolly-viewport>
  <scrolly-bar axis="y"></scrolly-bar>
  <scrolly-bar axis="x"></scrolly-bar>
 
</scrolly> -->
  <!-- <div>
    <br>
    <p class="mt-3">Current Page: {{ currentPage }}</p>
     

      <b-pagination v-model="currentPage" align="right"  aria-controls="my-table"  :per-page="perPage" pills :total-rows="rows" ></b-pagination>
    </div> -->
  <!-- <vs-pagination max-items="10" v-model="alertlist" :data="alertlist" ></vs-pagination> -->
 
    
    </vs-card>
  </vs-col>
  <vs-col vs-type="flex" vs-justify="center"  vs-w="4" vs-sm="6" vs-xs="12" >
    <vs-card style=" border-radius: 20px;">
       <vs-list  >
    <vs-list-header icon="wifi" title="Network List" style="font-size: 18px;" color="#fd9426"></vs-list-header>
 <scrolly class="foo" :style="{ width: '100%', height: '200px' , overflow: 'auto' }">
  <scrolly-viewport>
      
     <vs-collapse   >
     <vs-collapse-item   v-for="item in nwlist" :key="item.id">
       <div slot="header">
        
 

         <h6><span><vs-icon icon="done" color="#fd9426" size="15px"></vs-icon></span> {{item.name}}</h6>
       </div>
       &nbsp;&nbsp;&nbsp;&nbsp;   <a style="color:#28a745;"><span><vs-icon icon="router" size="15px"></vs-icon>
                                    </span>&nbsp;Gateways :&nbsp;{{item.gwc}}</a>  &nbsp;&nbsp;&nbsp;
                                 
                                    <a style="color:#147efb;"><span><vs-icon icon="signal_cellular_alt" size="15px"></vs-icon>
                                    </span>&nbsp;Sensors :&nbsp;{{item.sc}}</a>
                                 
        
        </vs-collapse-item>
     
    </vs-collapse>
  
  </scrolly-viewport>
  <scrolly-bar axis="y"></scrolly-bar>
 
</scrolly>
</vs-list>
 
    <vs-pagination :total="totalpage"  v-model="current"  ></vs-pagination>
   
    </vs-card>
     
  </vs-col>
</vs-row>

</template>

<script>
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';

 
export default {
  name: "ShowNetwork",
  components: {
    Scrolly,
    ScrollyViewport,
    ScrollyBar,
    
  },
  data: () => ({
    nwlist: [],
    totalpage: 1,
    perPage: 3,
    currentPage: 1,
    filternw: [],
    current: 1,
    alertlist: [],
    // alertlist: [{"name":"Test Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45"},
    // {"name":"Test Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45"},
    // {"name":"Test Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45"},
    // {"name":"Test Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45"},
    // {"name":"Test Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45"},
    // {"name":"Test Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45"}
    // ,{"name":"Test Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45"}],
    sensorlist: []
  }),
 
  // watch:{
  //     test() {
  //       this.filternw = this.nwlist.splice((this.current-1),(this.current+2))
  //       // console.log(this.filternw)
  //       return this.current
  //     }
  // },
  methods: {
    link(nw){
      this.$router.push({
        name: 'ViewNetwork',
        params: {
          id: nw.id,
          name: nw.name,
          sc: nw.sc,
          gwc: nw.gwc
        }
      })
    },
    del(nw){
      this.$API.post('networkdel', {
        name: nw.name
      }).then(() => {})
      this.$vs.notify({
        title: "Delete Network",
        text: "Complete!",
        color: "danger",
        position: "top-center",
        icon: 'check'
      });
      this.$forceUpdate();
    }
  },
  created() {
    this.$API.get('network/user').then((result)=>{
      this.nwlist = result.data
      this.totalpage = Math.round(this.nwlist.length/4)
      this.current = 1
      var j = 0
      var temp =[]
      // for(let i = 0 ; i< this.totalpage ; i++){
      //   temp = this.nwlist
      //   this.filternw.push(temp.splice(j,j+5))
      //   j+=4

      // }
      // console.log(this.filternw,this.nwlist)

    })
  },
   computed: {
      rows() {
        return this.alertlist.length
        // console.log(this.alertlist.length)
      }
    },
}

</script>

<style scoped>
.span {
  font-size: 14px;
}
.vs-pagination--mb {
    margin-top: 20px;
    
}
#noWrap{
  padding: 0px; 
  white-space: nowrap; 
}
element.style {
    justify-content: flex-end;
    display: flex;
    align-items: center;
    margin-left: 0%;
    width: 100%;
    background: #ffffff;
}
</style>